// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== Project Card ==================== */
.project-card {
    position: relative;
    /* The card is the reference for its own internals (see the stats grid):
       three cards on a 1920 screen are ~350px wide each, which a viewport media
       query cannot distinguish from a 350px phone. */
    container-type: inline-size;
    background: var(--card);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--border);
    overflow: hidden;
    cursor: pointer;
    transition: background-color var(--transition), border-color var(--transition), box-shadow var(--transition), transform var(--transition);
    /* The grid owns the spacing between cards (.lf-grid-auto's gap); a margin
       here would double it and break the card's own height in a grid cell. */
    margin: 0;
    height: 100%;
  }

  .project-card:hover {
    background: var(--card-hover);
    box-shadow: var(--shadow-md);
    border-color: var(--border-strong);
    transform: translateY(-2px);
  }

  /* Accent Bar - Hidden */
  .project-card__accent-bar {
    display: none;
  }

  /* Content Container */
  .project-card__content {
    padding: clamp(16px, 4%, 24px);
    position: relative;
    z-index: 1;
  }

  /* ==================== Header Section ==================== */
  .project-card__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 12px;
  }

  .project-card__info {
    flex: 1 1;
    min-width: 0;
  }

  .project-card__title-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
  }

  .project-card__icon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, var(--brand-500), var(--brand-700));
    border-radius: var(--radius);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 6px -1px var(--ring);
  }

  .project-card__icon i {
    color: var(--primary-foreground);
    font-size: 18px;
  }

  .project-card__title-info {
    flex: 1 1;
    min-width: 0;
  }

  .project-card__title {
    font-size: 18px;
    font-weight: 600;
    color: var(--foreground);
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: color var(--transition);
  }

  .project-card:hover .project-card__title {
    color: var(--primary);
  }

  .project-card__subtitle {
    font-size: 13px;
    color: var(--muted-foreground);
    margin: 0;
  }

  .project-card__detail {
    font-size: 14px;
    color: var(--muted-foreground);
    line-height: 1.5;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  /* ==================== Menu (uses labelflow-dropdown-* from master) ==================== */
  .project-card__menu {
    position: relative;
    margin-left: 8px;
    flex-shrink: 0;
  }

  /* ==================== Model Types Section ==================== */
  .project-card__section {
    margin-bottom: 20px;
  }

  .project-card__section-label {
    font-size: 11px;
    font-weight: 600;
    color: var(--muted-foreground);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0 0 8px 0;
  }

  .project-card__badges {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .project-card__badge {
    display: inline-flex;
    align-items: center;
    padding: 6px 12px;
    border-radius: var(--radius-full);
    font-size: 12px;
    font-weight: 500;
    background: var(--accent);
    color: var(--accent-foreground);
    border: 1px solid var(--border);
  }

  /* ==================== Stats Section ==================== */
/* Fallback for engines without container queries: fit what fits. */
.project-card__stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(150px, 100%), 1fr));
    gap: 12px;
  }

/* With container queries, answer the only question that matters — is THIS card
   wide enough for three tiles? A tile is a 40px icon plus a value and a word
   ("Running"), so it wants ~130px before the label wraps; three of those need a
   ~430px card. Between that and a phone, two columns with the odd tile spanning
   the row — auto-fit alone lands on 2+1 with a hole where a tile should be. */
@container (min-width: 430px) {
    .project-card__stats {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
@container (min-width: 300px) and (max-width: 429.98px) {
    .project-card__stats {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .project-card__stat:nth-child(3):last-child {
      grid-column: 1 / -1;
    }
  }
@container (max-width: 299.98px) {
    .project-card__stats {
      grid-template-columns: minmax(0, 1fr);
    }
  }

.project-card__stat {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px;
    border-radius: var(--radius);
    border: 1px solid var(--border);
  }

  .project-card__stat--success {
    background: var(--primary-soft);
  }

  .project-card__stat--warning {
    background: var(--warning-soft);
  }

  .project-card__stat--info {
    background: var(--info-soft);
  }

  .project-card__stat-icon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: var(--radius);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: var(--shadow-sm);
  }

  .project-card__stat--success .project-card__stat-icon {
    background: var(--success);
    color: var(--background);
  }

  .project-card__stat--warning .project-card__stat-icon {
    background: var(--warning);
    color: var(--background);
  }

  .project-card__stat--info .project-card__stat-icon {
    background: var(--info);
    color: var(--background);
  }

  .project-card__stat-icon--pulse {
    animation: iconPulse 2s ease-in-out infinite;
  }

  @keyframes iconPulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }

  .project-card__stat-icon i {
    font-size: 18px;
  }

  .project-card__stat-info {
    flex: 1 1;
  }

  .project-card__stat-value {
    font-size: 22px;
    font-weight: 700;
    color: var(--foreground) !important;
    margin: 0 0 2px 0;
    line-height: 1;
  }

  .project-card__stat-label {
    font-size: 11px;
    color: var(--muted-foreground);
    font-weight: 600;
    margin: 0;
  }

  /* ==================== Hover Overlay ==================== */
  .project-card__hover-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--primary-soft);
    opacity: 0;
    transition: opacity var(--transition);
    pointer-events: none;
  }

  .project-card:hover .project-card__hover-overlay {
    opacity: 0.35;
  }

/* ==================== Responsive ==================== */
/* Column count is handled by the auto-fit grid above at every width; what is
   left here is genuine small-screen density. */
@media (max-width: 768px) {
    .project-card__header {
      margin-bottom: 16px;
    }

    .project-card__title {
      font-size: 16px;
    }

    .project-card__detail {
      font-size: 13px;
    }

    .project-card__stats {
      gap: 10px;
    }

    .project-card__stat {
      padding: 12px;
    }

    .project-card__stat-value {
      font-size: 20px;
      color: var(--foreground) !important;
    }
  }

/* Very narrow cards / phones: the icon + value + label row needs ~150px, so
   below that let a tile keep one per row and shrink its icon. */
@media (max-width: 400px) {
    .project-card__stat {
      gap: 8px;
      padding: 10px;
    }

    .project-card__stat-icon {
      width: 34px;
      height: 34px;
    }

    .project-card__stat-icon i {
      font-size: 15px;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/pages/management/projectManagement/components/ProjectCard.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;IACI,kBAAkB;IAClB;;qDAEiD;IACjD,2BAA2B;IAC3B,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;IAC5B,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;IACf,yIAAyI;IACzI;6EACyE;IACzE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;IAC5B,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA,wBAAwB;EACxB;IACE,aAAa;EACf;;EAEA,sBAAsB;EACtB;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,UAAU;EACZ;;EAEA,6DAA6D;EAC7D;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,uEAAuE;IACvE,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;EACxC;;EAEA;IACE,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,mCAAmC;EACrC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;IAChB,SAAS;IACT,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA,2FAA2F;EAC3F;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;;EAEA,kEAAkE;EAClE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,+BAA+B;IAC/B,+BAA+B;EACjC;;EAEA,4DAA4D;AAC9D,mEAAmE;AACnE;IACI,aAAa;IACb,sEAAsE;IACtE,SAAS;EACX;;AAEF;;;;8EAI8E;AAC9E;IACI;MACE,gDAAgD;IAClD;EACF;AACF;IACI;MACE,gDAAgD;IAClD;;IAEA;MACE,mBAAmB;IACrB;EACF;AACF;IACI;MACE,qCAAqC;IACvC;EACF;;AAEF;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,YAAY;IACd;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;IAChB,SAAS;EACX;;EAEA,4DAA4D;EAC5D;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,UAAU;IACV,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;AAEF,yDAAyD;AACzD;+CAC+C;AAC/C;IACI;MACE,mBAAmB;IACrB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;MACf,mCAAmC;IACrC;EACF;;AAEF;gEACgE;AAChE;IACI;MACE,QAAQ;MACR,aAAa;IACf;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":["/* ==================== Project Card ==================== */\n.project-card {\n    position: relative;\n    /* The card is the reference for its own internals (see the stats grid):\n       three cards on a 1920 screen are ~350px wide each, which a viewport media\n       query cannot distinguish from a 350px phone. */\n    container-type: inline-size;\n    background: var(--card);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-sm);\n    border: 1px solid var(--border);\n    overflow: hidden;\n    cursor: pointer;\n    transition: background-color var(--transition), border-color var(--transition), box-shadow var(--transition), transform var(--transition);\n    /* The grid owns the spacing between cards (.lf-grid-auto's gap); a margin\n       here would double it and break the card's own height in a grid cell. */\n    margin: 0;\n    height: 100%;\n  }\n\n  .project-card:hover {\n    background: var(--card-hover);\n    box-shadow: var(--shadow-md);\n    border-color: var(--border-strong);\n    transform: translateY(-2px);\n  }\n\n  /* Accent Bar - Hidden */\n  .project-card__accent-bar {\n    display: none;\n  }\n\n  /* Content Container */\n  .project-card__content {\n    padding: clamp(16px, 4%, 24px);\n    position: relative;\n    z-index: 1;\n  }\n\n  /* ==================== Header Section ==================== */\n  .project-card__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    gap: 12px;\n  }\n\n  .project-card__info {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .project-card__title-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 8px;\n  }\n\n  .project-card__icon {\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    background: linear-gradient(135deg, var(--brand-500), var(--brand-700));\n    border-radius: var(--radius);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 4px 6px -1px var(--ring);\n  }\n\n  .project-card__icon i {\n    color: var(--primary-foreground);\n    font-size: 18px;\n  }\n\n  .project-card__title-info {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .project-card__title {\n    font-size: 18px;\n    font-weight: 600;\n    color: var(--foreground);\n    margin: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    transition: color var(--transition);\n  }\n\n  .project-card:hover .project-card__title {\n    color: var(--primary);\n  }\n\n  .project-card__subtitle {\n    font-size: 13px;\n    color: var(--muted-foreground);\n    margin: 0;\n  }\n\n  .project-card__detail {\n    font-size: 14px;\n    color: var(--muted-foreground);\n    line-height: 1.5;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  /* ==================== Menu (uses labelflow-dropdown-* from master) ==================== */\n  .project-card__menu {\n    position: relative;\n    margin-left: 8px;\n    flex-shrink: 0;\n  }\n\n  /* ==================== Model Types Section ==================== */\n  .project-card__section {\n    margin-bottom: 20px;\n  }\n\n  .project-card__section-label {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--muted-foreground);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin: 0 0 8px 0;\n  }\n\n  .project-card__badges {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .project-card__badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 6px 12px;\n    border-radius: var(--radius-full);\n    font-size: 12px;\n    font-weight: 500;\n    background: var(--accent);\n    color: var(--accent-foreground);\n    border: 1px solid var(--border);\n  }\n\n  /* ==================== Stats Section ==================== */\n/* Fallback for engines without container queries: fit what fits. */\n.project-card__stats {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(150px, 100%), 1fr));\n    gap: 12px;\n  }\n\n/* With container queries, answer the only question that matters — is THIS card\n   wide enough for three tiles? A tile is a 40px icon plus a value and a word\n   (\"Running\"), so it wants ~130px before the label wraps; three of those need a\n   ~430px card. Between that and a phone, two columns with the odd tile spanning\n   the row — auto-fit alone lands on 2+1 with a hole where a tile should be. */\n@container (min-width: 430px) {\n    .project-card__stats {\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n  }\n@container (min-width: 300px) and (max-width: 429.98px) {\n    .project-card__stats {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .project-card__stat:nth-child(3):last-child {\n      grid-column: 1 / -1;\n    }\n  }\n@container (max-width: 299.98px) {\n    .project-card__stats {\n      grid-template-columns: minmax(0, 1fr);\n    }\n  }\n\n.project-card__stat {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 14px;\n    border-radius: var(--radius);\n    border: 1px solid var(--border);\n  }\n\n  .project-card__stat--success {\n    background: var(--primary-soft);\n  }\n\n  .project-card__stat--warning {\n    background: var(--warning-soft);\n  }\n\n  .project-card__stat--info {\n    background: var(--info-soft);\n  }\n\n  .project-card__stat-icon {\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    border-radius: var(--radius);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: var(--shadow-sm);\n  }\n\n  .project-card__stat--success .project-card__stat-icon {\n    background: var(--success);\n    color: var(--background);\n  }\n\n  .project-card__stat--warning .project-card__stat-icon {\n    background: var(--warning);\n    color: var(--background);\n  }\n\n  .project-card__stat--info .project-card__stat-icon {\n    background: var(--info);\n    color: var(--background);\n  }\n\n  .project-card__stat-icon--pulse {\n    animation: iconPulse 2s ease-in-out infinite;\n  }\n\n  @keyframes iconPulse {\n    0%, 100% {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.7;\n    }\n  }\n\n  .project-card__stat-icon i {\n    font-size: 18px;\n  }\n\n  .project-card__stat-info {\n    flex: 1;\n  }\n\n  .project-card__stat-value {\n    font-size: 22px;\n    font-weight: 700;\n    color: var(--foreground) !important;\n    margin: 0 0 2px 0;\n    line-height: 1;\n  }\n\n  .project-card__stat-label {\n    font-size: 11px;\n    color: var(--muted-foreground);\n    font-weight: 600;\n    margin: 0;\n  }\n\n  /* ==================== Hover Overlay ==================== */\n  .project-card__hover-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: var(--primary-soft);\n    opacity: 0;\n    transition: opacity var(--transition);\n    pointer-events: none;\n  }\n\n  .project-card:hover .project-card__hover-overlay {\n    opacity: 0.35;\n  }\n\n/* ==================== Responsive ==================== */\n/* Column count is handled by the auto-fit grid above at every width; what is\n   left here is genuine small-screen density. */\n@media (max-width: 768px) {\n    .project-card__header {\n      margin-bottom: 16px;\n    }\n\n    .project-card__title {\n      font-size: 16px;\n    }\n\n    .project-card__detail {\n      font-size: 13px;\n    }\n\n    .project-card__stats {\n      gap: 10px;\n    }\n\n    .project-card__stat {\n      padding: 12px;\n    }\n\n    .project-card__stat-value {\n      font-size: 20px;\n      color: var(--foreground) !important;\n    }\n  }\n\n/* Very narrow cards / phones: the icon + value + label row needs ~150px, so\n   below that let a tile keep one per row and shrink its icon. */\n@media (max-width: 400px) {\n    .project-card__stat {\n      gap: 8px;\n      padding: 10px;\n    }\n\n    .project-card__stat-icon {\n      width: 34px;\n      height: 34px;\n    }\n\n    .project-card__stat-icon i {\n      font-size: 15px;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
